import React from 'react';
import styled from 'styled-components';
import Nav from '../Nav/Nav';
import Logo from '../Logo/Logo';

const StyledHeader = styled.header`
  position: relative;
  padding: 30px 30px 0 30px;
  overflow: hidden;

  .header-logo {
    float: left;
    margin-bottom: 0 !important;
  }

  .nav {
    float: right;
  }
`;

const Header = () => (
  <StyledHeader>
    <Logo size="small" className="header-logo" />
    <Nav className="nav" />
  </StyledHeader>
);

export default Header;
